import {controller, target} from '@github/catalyst'
import {announceFromElement} from '../aria-live'

@controller
class RetentionFormElement extends HTMLElement {
  @target group: HTMLElement
  @target input: HTMLInputElement
  @target button: HTMLButtonElement
  @target minMessage: HTMLElement
  @target maxMessage: HTMLElement
  @target note: HTMLElement

  validate() {
    this.resetState()

    if (!this.input.value) return

    const value: number = +this.input.value
    const min_string = this.input.getAttribute('data-min')
    const max_string = this.input.getAttribute('data-max')

    if (min_string && value < +min_string) {
      this.group.classList.add('errored')
      this.minMessage.hidden = false
      announceFromElement(this.note)
      return
    }

    if (max_string && value > +max_string) {
      this.group.classList.add('errored')
      this.maxMessage.hidden = false
      announceFromElement(this.note)
      return
    }

    this.button.disabled = false
  }

  resetState() {
    this.minMessage.hidden = true
    this.maxMessage.hidden = true
    this.group.classList.remove('errored')
    this.button.disabled = true
  }
}
